import React, { useState } from 'react';
import shortid from 'shortid';

import { useMarketData } from 'context/market';
import Filters from 'components/filters';

import { marketView, marketViewFilters } from './scss/MarketView.module.scss';
import {
  renderCellValue,
  filterMarketViewList,
  getUniqueMarketViewCategories,
} from './MarketView.helpers';

const MarketView = () => {
  const {
    marketView: { rows, columns },
  } = useMarketData();
  const marketViewCategories = getUniqueMarketViewCategories(rows);
  const [filterValue, setFilterValue] = useState(marketViewCategories[0]);
  const marketViewList = filterMarketViewList(rows, filterValue);

  return (
    <div className={marketView}>
      {marketViewCategories.length > 1 && <Filters
        className={marketViewFilters}
        options={marketViewCategories}
        theme="dark"
        onSelect={setFilterValue}
      />}
      <div className="table-responsive">
        <table>
          <thead>
            <tr>
              {columns.map(
                column =>
                  column.visible && (
                    <th key={shortid()}>{column.displayName}</th>
                  )
              )}
            </tr>
          </thead>
          <tbody>
            {marketViewList.map(item => {
              return (
                <tr key={shortid()}>
                  {columns.map(
                    column =>
                      column.visible && (
                        <td key={shortid()}>{renderCellValue(column, item)}</td>
                      )
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarketView;
